import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import Box from "node_modules/@mui/material/esm/Box/Box";
import { useRef } from "react";

export function TrackedLink({
  href,
  label,
  children,
}: {
  href: string;
  label?: string;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLAnchorElement>(null);
  const handleClick = () => {
    CreateAnalyticEvent({
      event: {
        adIds: ["NONE"],
        eventType: "CLICK#LINK#OUT",
        metadata: {
          href: href,
          label: label || "NONE",
          text: ref.current?.textContent || "NONE",
        },
      },
    });
  };

  return (
    <Box
      ref={ref}
      component="a"
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={handleClick}
    >
      {children}
    </Box>
  );
}
